/* src/app/modules_v2/admin/admin-verifactu-authorization/admin-verifactu-authorization-list/admin-verifactu-authorization-list.component.css */
.custom-badge {
  padding: 0.4rem 0.75rem;
  font-size: 0.9rem;
  font-weight: 500;
  border-radius: 0.5rem;
  display: inline-block;
  line-height: 1.2;
}
.badge.bg-primary.custom-badge {
  background-color: var(--cf-brand-dark) !important;
  color: white;
}
/*# sourceMappingURL=admin-verifactu-authorization-list.component.css.map */
